import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
module.exports = {
  ...zhLocale,
  selectLanguage: '选择语言',
  chinese: '中文',
  english: '英文',
  logout: '退出登录',
  netError: '网络连接错误，请稍后重试',
  cancel: '取消',
  confirm: '确定',
  delete: '删除',
  save: '保存',
  recovery: '恢复',
  rename: '重命名',
  userSpace: '个人空间',
  entSpace: '企业空间',
  allUser: '所有用户',
  frozen: '已冻结',
  upload: '上传',
  import: '导入',
  tips: '提示',
  prompt: '提示',
  success: '成功',
  return: '返回',
  edit: '编辑',
  close: '关闭',
  noSearch: '搜索无结果',
  loadmore: '加载更多',
  retry: '重试',
  allDelete: '全部删除',
  nextStep: '下一步',
  nodata: '没有相关的查询结果',
  back: '上一步',
  gotIt: '知道了',
  ad: 'AD',
  corpWX: '企业微信',
  dingding: '钉钉',
  weaverOA: '泛微OA',
  weaver: '泛微',
  LDAP: 'LDAP',
  ADFS: 'ADFS',
  kingdee: '金蝶云',
  captcha_plugin_wechat: '企业微信',
  approve_plugin_weaver: '泛微审批',
  moduleType: '模块类型',
  serviceType: '服务类型',
  search: '查询',
  discription: '描述',
  creater: '创建者',
  createTime: '创建时间',
  version: '版本号',
  status: '状态',
  operation: '操作',
  read: '查看',
  start: '启动',
  stop: '停止',
  data: '数据结构',
  create: '新建',
  pending: '准备',
  readStatus: '查看状态',
  runing: '运行',
  toDelete: '确认删除',
  more: '更多',
  batchStart: '批量启动',
  batchStop: '批量停止',
  batchDelete: '批量删除',
  login: '登录',
  area: '搜索国家/地区',
  common: '常用',
  areaNull: '未找到相关国家或地区',
  phonePlaceholder: '请输入手机号码',
  actionSuccess: '操作成功',
  networkError: '网络连接失败',
  verificationError: '验证码错误',
  frozenTip: '您的账号已被冻结，请联系您的系统管理员！',
  passwordError: '您输入的密码不正确',
  loginError: '登录失败',
  mobile: '手机号',
  slug: '登录名',
  email: '邮箱',
  edas: {
    customfilter_err: '最多可输入256个字',
    scheme: '连接类型',
    empty_data: '暂无数据',
    autoLogin: '通过三方系统唤起客户端并且自动登录（支持：Windows、Mac、iPhone、Android）',
    bindingConfig: '第三方绑定',
    binding: '第三方绑定服务配置',
    deliveryDefaultLoginTip: '对链接登录场景生效',
    api: 'openapi',
    uploadLable: '已上传',
    unUploadLabl: '未上传',
    startLabl: '已启动',
    unStartLabl: '未启动',
    stopedLabl: '已停止',
    unStopLabl: '未停止',
    deleteLabl: '已删除',
    unDeleteLabl: '未删除',
    exportFilter: '条件导出',
    pleaseEnter: '请输入',
    proxyService: '代理服务',
    syntaxError: '语法错误',
    iconFormatLimit: '仅支持上传PNG格式',
    iconBulkLimit: '图片必须小于50KB',
    iconSizeLimit: '图片必须为40*40px以上',
    iconScaleLimit: '图片必须为1:1',
    iconTip: '请上传PNG格式、40*40PX以上、 1:1 、50KB以内的图标',
    loginIcon: '登录图标',
    filterCondition: '设置过滤条件',
    enterFilter:
      '设置过滤条件后，会将Base DN下的节点按照设定的过滤条件进行过滤，目前支持LDAP filter语法格式，如cn=D_group1',
    delConfirm: '是否确认删除',
    ad: 'AD',
    baseDN: 'Base DN',
    appId: 'appId',
    ProviderSecret: 'ProviderSecret',
    secret: 'secret',
    appKeySecret: 'appKeySecret',
    URL: 'URL',
    LDAP: 'LDAP',
    ADFS: 'ADFS',
    authentication: '企业认证',
    agentId: 'agentId',
    status: '状态',
    operation: '操作',
    next: '下一步',
    last: '上一步',
    delete: '删除',
    tips: '提示',
    departmentID: '部门标识字段',
    departmentName: '部门名称字段',
    parentDepartment: '父部门',
    agentTips: '当前服务类型无需选择代理名称',
    hours: '时',
    mins: '分',
    more: '更多',
    back: '返回',
    detail: '详情',
    object: '对象',
    action: '动作',
    remarks: '备注',
    team: '团队',
    move: '移动',
    frozen: '冻结',
    netError: '网络连接错误，请稍后重试',
    setFilter: '设置过滤条件',
    import: '导入',
    modify: '修改',
    upload: '上传',
    edit: '编辑',
    condition: '个条件',
    loadMore: '加载更多',
    items: '项',
    urlTip: '请输入带http://或https://的URL',
    title: '企业账户认证',
    subHeader: '您可以将开放平台与企业域对接，快速导入及同步企业已有用户和组织架构。',
    importServerConfig: '组织导入服务配置',
    sync: '组织导入服务配置',
    authServerConfig: '登录认证服务配置',
    auth: '登录认证服务配置',
    agentName: '代理名称',
    serviceName: '服务名称',
    serial: '序列号',
    ctime: '创建时间',
    addAgentServer: '添加代理服务',
    addServerConfig: '添加服务配置',
    editServerConfig: '编辑服务配置',
    add_import_config: '添加组织导入服务配置',
    add_auth_config: '添加登录认证服务配置',
    add_binding_config: '添加第三方绑定服务配置',
    add_sso_config: '添加单点登录服务配置',
    add_scan_config: '添加扫码登录服务配置',
    edit_import_config: '编辑组织导入服务配置',
    edit_auth_config: '编辑登录认证服务配置',
    edit_binding_config: '编辑第三方绑定服务配置',
    edit_sso_config: '编辑单点登录服务配置',
    edit_scan_config: '编辑扫码登录服务配置',
    autoSyncTime: '自动同步时间',
    lastSyncTime: '上次同步时间',
    newAgentSrver: '新建代理服务',
    unbound: '解除绑定',
    unbind: '未绑定',
    normal: '正常',
    disconnect: '断开',
    hasAddAgentServer: '代理服务已添加',
    unboundTips: '解除绑定后，该代理服务不可用，是否继续解除？',
    confirmUnbound: '继续解除',
    deleteTips: '删除后，该服务将解绑并清除相关参数，是否继续？',
    serviceType: '服务类型',
    corpWX: '企业微信',
    dingding: '钉钉',
    weaver: '泛微',
    weaverOA: '泛微OA',
    oauth2: 'Oauth2',
    doublecase: '双因子',
    customize: '自定义',
    none: '无',
    submit: '提交',
    connectConfig: '连接配置',
    serviceAddress: '服务器地址',
    serviceManageAccount: '服务器管理账号',
    password: '密码',
    port: '端口',
    fieldMapping: '字段映射',
    introduction:
      '说明: 因企业微信政策规定，从2022年6月20日之后创建的自建应用无法获取到邮箱和手机号，因此通过企业微信导入的账号仅能使用单点登录和扫码登录。导入成功的账号在zBox系统内可以手动添加邮箱、手机号。 若您使用的自建应用在2022年6月20日之前创建，则可以正常同步邮箱和手机号。',
    userID: '用户标识字段',
    userNameField: '用户名称字段',
    emailField: '用户邮箱字段',
    mobileField: '用户手机字段',
    login: '用户登录字段',
    teamID: '团队标识字段',
    teamName: '团队名称字段',
    allowMailImportToBeEmpty: '邮箱导入允许为空',
    mailImportToolTip: '如果去掉勾选,即不允许为空,则邮箱为空的用户不导入',
    customField: '自定义字段',
    lenovoboxField: '网盘字段',
    importField: '导入字段',
    addField: '添加字段',
    syncConfig: '同步配置',
    defaultImportMode: '默认导入方式',
    allImport: '全部导入',
    allNoImport: '全部不导入',
    syncMode: '同步方式',
    syncOrganization: '同步到组织',
    syncTeam: '同步到团队',
    syncUserOnly: '仅同步用户',
    syncOrganizationToolTip: '将对接系统的组织和人员同步到云端组织中',
    syncTeamToolTip: '将对接系统的人员同步到组织下，将对接系统的组织结构同步到团队中',
    syncTeamToolTipNotEnterPrise: '将对接系统的组织结构同步到团队中',
    syncUserOnlyToolTip: '仅将对接系统的人员同步到组织根节点下，不同步组织',
    syncUserOnlyToolTipNotEnterPrise: '仅将对接系统的人员同步到团队根节点下，不同步组织',
    syncTime: '同步执行时间',
    accordingDay: '按天',
    accordingHour: '按时',
    hour: '时',
    min: '分',
    adfsCertificate: 'adfs证书 (jks格式)',
    certificatePassword: '证书密码',
    adfsAddress: 'ADFS地址',
    everyday: '每天',
    every: '每',
    syncOperation: '立即同步',
    log: '日志',
    setServiceConfig: '设置服务配置',
    setFiltrationConditions: '设置过滤条件',
    deleteSuccess: '已删除成功',
    syncCompleteTime: '同步完成时间',
    syncSuccess: '同步成功',
    syncFail: '同步失败',
    unSync: '未同步',
    unSyncToolTip: '通过黑名单过滤未同步的数据',
    export: '导出',
    syncDetail: '同步详情',
    detailSyncTime: '同步时间',
    allSyncResult: '全部同步结果',
    failReasons: '失败原因',
    fail: '失败',
    user: '用户',
    created: '创建',
    update: '更新',
    unfrozen: '解冻',
    filter: '已过滤',
    unSyncUser: '未同步用户',
    unSyncTeam: '未同步团队',
    importServiceConfigCuccess: '添加导入服务配置成功！',
    filterInquiry: '是否立即去设置导入过滤条件？',
    noSettings: '暂不设置',
    goSettings: '前往设置',
    addFilter: '添加条件',
    addFilterCondition: '添加过滤条件',
    modifyFilterCondition: '修改过滤条件',
    batchImport: '批量导入',
    userEmail: '用户邮箱',
    userPhone: '用户手机',
    userName: '用户名称',
    teamUser: '团队名称',
    filteringContent: '过滤内容',
    allConditionalType: '全部条件类型',
    allFilterMode: '全部过滤方式',
    noImport: '不导入',
    conditionalType: '条件类型',
    filterMode: '过滤方式',
    importModeDesc: '导入方式可在服务配置中修改',
    addedNumber: '已添加',
    addedText: '个条件',
    first: '第一步',
    downloadTemp: '下载模板',
    downloadTempDesc: 'xls或xlsx文件',
    second: '第二步',
    editedUpload: '编辑内容后，上传',
    uploadCertificate: '上传证书',
    deleteItem: '删除选中项',
    selectedText: '确定删除选中的',
    importLogTitle: '导入配置的日志列表',
    mostNumber: '最多10条字段',
    enterLenovoboxField: '请输入网盘字段',
    enterImportField: '请输入导入字段',
    agentRelease: '代理绑定已解除',
    noServiceConfig: '未添加服务配置',
    noAgentService: '未添加代理服务',
    syncConfigDesc: '提交后，可添加过滤条件筛选部分用户',
    noDetailResulr: '没有相应的搜索结果',
    filterTitleTip: '默认导入全部数据，可设置全部不导入，通过添加条件来导入部分数据',
    importAcount: '总计导入',
    copy: '复制',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    serviceNamePlaceholder: '请输入服务配置名称，最多50个字符',
    serviceAddressPlaceholder: '例如：120.22.100.11',
    manageAccountPlaceholder: '请输入将要连接的服务器管理账号',
    enterPasswordPlaceholder: '请输入密码',
    verificationRequired: '请输入验证码',
    verificationTip: '看不清请点击',
    enterSearchValue: '请输入搜索内容',
    selectFilterType: '请选择过滤条件类型',
    enterEmail: '请输入用户邮箱',
    enterUserPhone: '请输入用户手机',
    enterUserName: '请输入用户名称',
    enterTeamName: '请输入团队名称',
    noSearchResult: '请输入团队名称请换个关键词再试试',
    beyondLimit: '超出10000条上限',
    configSuccess: '配置成功',
    deleteConfirm: '确认删除？',
    item: '个',
    noFilterSearchResult: '无相应的搜索结果，请换个关键词再试试',
    character: '请输入服务配置名称，最多50字符',
    noErrorSpecialCharacters: '不允许输入以下下特殊字符"\\/:*?\'<>|"',
    isSyncing: '执行同步中',
    jksFile: 'jks格式',
    uploadJksFile: '请上传jks格式文件',
    inputCertificatePassword: '请输入证书密码',
    address: '请输入地址',
    modifySuuccess: '修改成功',
    agentPlaceholder: '请输入代理服务名称，最多50个字符',
    inputTeamOrUser: '输入用户名/团队名搜索',
    addFilterSuccess: '添加过滤条件成功',
    modifyFilterSuccess: '修改过滤条件成功',
    errorEmail: '邮箱格式不正确',
    errorMobile: '手机格式不正确',
    bindingServerConfig: '第三方绑定服务配置',
    matchingRule: '匹配规则',
    mobile: '手机号',
    email: '邮箱',
    syncResult: '同步结果',
    newBinding: '新绑定',
    failBinding: '绑定失败',
    account: '账号',
    bindingLogTitle: '绑定配置的日志列表',
    inputAccount: '请输入账号',
    organization: '组织',
    unSyncOrganization: '未同步组织',
    mostCustomNumber: '最多{0}条字段',
    createAgentFirst: '请先配置代理服务',
    hasNoAgentNow: '暂无代理服务',
    notNeedAgent: '当前服务类型无需选择代理名称',
    connectFieldName: '连接配置项名称',
    connectFieldContent: '连接配置项内容',
    enterConnectFieldName: '请输入连接配置项名称',
    enterConnectFieldContent: '请输入连接配置项内容',
    sso: '单点登录（SSO）服务配置',
    identification: '匹配标识',
    signCongit: '扫码登录服务配置',
    sign: '扫码登录服务配置',
    scanName: '登录名',
    boxUrl: '网盘访问地址',
    copyUrl: '复制地址',
    ssoWarning:
      '由于您使用了代理服务，系统无法获取到代理服务器地址，因此请您在使用网盘访问地址时，需手动将代理服务的IP或地址填写在xxx位置，例如：https://lenovows.com/user/manage',
    agentWarning: '代理服务最多添加1个配置',
    importWarning: '组织导入服务最多添加1个配置',
    authWarning: '登录认证服务最多添加1个配置',
    schema: 'schema',
    userStatus: '用户状态',
    probation: '试用',
    formal: '正式',
    temporary: '临时',
    probationExtension: '试用延期',
    dismissal: '解聘',
    resignation: '离职',
    retirement: '退休',
    invalid: '无效,只同步正式用户',
    importSealTeam: '导入封存团队',
    yes: '是',
    no: '否',
    relationship: '关系',
    appIdMobile: 'appIdMobile',
    appSecretMobile: 'appSecretMobile',
    applicationVoucher: '应用凭证',
    applicationVoucherTitle: '配置连接钉钉的应用凭证，用于获取钉钉用户的基础信息',
    scanLogin: '扫码登录服务配置',
    qrcode: '扫码登录服务配置',
    scanLoginTitle: '配置钉钉扫码登录应用授权信息，以实现钉钉扫码登录网盘',
    mobileAuthorizedLogin: '移动端授权登录',
    mobileAuthorizedLoginTitle:
      '配置钉钉“移动应用接入-分享”授权信息，以实现移动端可以通过钉钉授权登录',
    kingdee: '金蝶云',
    createSuperiorTeam: '自动创建上级团队',
    createSuperiorOrg: '自动创建上级组织',
    autCreateSuperiorTeam: '添加的过滤条件同步到团队时自动创建上级团队',
    autCreateSuperiorOrg: '添加的过滤条件同步到组织时自动创建上级组织',
    all: '选择全部',
    serviceList: '插件管理',
    searchSuccess: '查询成功',
    uploadError: '上传失败',
    confirmClose: '确认关闭？',
    confirmOperation: '确认批量处理吗？',
    loading: '请稍等...',
    allSuccess: '批量操作成功',
    startSuccess: '启动成功',
    closeSuccess: '关闭成功',
    uploadSuccess: '上传成功',
    marne_captcha_config: '双因子登录集成',
    marne_approve_config: '审批集成',
    feishu: '飞书',
    okta: 'Okta',
    browse: '浏览',
    browse_error: '请输入正确的Base DN',
    browse_tip: '修改Base DN会影响已经配置的过滤条件，可能会导致过滤条件失效，请谨慎修改',
    condition_filter: '过滤条件',
    filter_type: '按类型过滤',
    filter_condition: '按条件过滤',
    filter_custom: '自定义过滤条件',
    user: '用户',
    ou: '组织单元',
    group: '组',
    filter_type_tip: '按类型设置过滤条件时，会将Base DN下的数据按照以上选中的类型同步至zBox系统内',
    add_condition: '添加条件',
    condition_has_added: '已添加该条件',
    filter_condition_tip: '按条件设置过滤方式时，会将所选择的指定对象同步至zBox系统内',
    repeat_condition_tip:
      '以下条件的上级节点已经被添加为条件，因此这些条件将被自动删除，删除后不影响最终导入范围',
    set_condition: '设置过滤条件',
    filter_custom_placeholder: '请输入您的过滤条件如cn=D_group1',
    all_types: '全部类型',
    filter_settings: '过滤设置',
    filter_method: '过滤方式',
    search: '搜索',
    checked_items: '已勾选{x}项',
    total_items: '共{x}项',
    selected_items: '已选中{x}项',
    select_all: '全选',
    select: '选择',
    connect_error: '无法连接服务器',
    connect_error_tip: '可能连接信息配置错误或者服务器异常',
    add: '添加',
    select_baseDN: '选择Base DN',
  },
  app: {
    reset: '重置',
    confirmReset: '确认重置',
    cancel: '取消',
    resetTile: '确认重置App Secret吗？',
    resetDesc: '重置后现有的App Secret将会失效，可能影响部分功能',
    resetSuccess: '重置成功',
    resetError: '重置失败',
    usePackageRequird: '必须输入应用包数量',
    usePackageRate: '不能小于已设置频率{0}/100',
    UsePackageNum: '使用应用包数量',
    UsedPackageNum: '已用应用包数量',
    updateTime: '更新时间',
    surplus: '剩余{0}个',
    packageCreateTip: '应用包数量不足，无法创建',
    packageSetTip: '应用包数量不足，无法设置',
    packageRateLimit: '如需设置更大范围的接口频率次数，需要增加应用包数量',
    usePackageTip:
      '1个应用包可以创建1个应用，可配置的接口频率为1分钟100次。也可使用多个应用包在一个应用上增加接口频率次数。',
    currentPackageNum: '当前可用应用包数量',
    thirdApp: '第三方应用',
    appManager: '应用管理',
    createApp: '创建应用',
    appName: '应用名称',
    appDesc: '应用描述',
    appIcon: '应用图标',
    ipManage: 'IP管理',
    addApiIp: '添加IP访问',
    appNameTip: '请输入应用名称，不超过50个字符',
    addIpDesc:
      '填写访问此应用的IP，多个IP请以“，”隔开，支持填写IP段，IP起始地址与终止地址使用“-”隔开',
    rateLimit: '接口频率限制',
    setRateLimit: '设置接口频率',
    rateLimitDesc:
      '为防止应用程序频繁调用而引发服务器负载异常，默认情况下，每个服务端接口调用都有频率限制，当超过此限制时，调用对应接口时会返回对应错误码。',
    rateLimitNumber: '需要提示上限数字',
    rateLimitUnit: '次/分钟',
    appVoucher: '应用凭证',
    apiBaseInfo: '基础信息',
    appAvatar: '应用图标',
    editInfo: '编辑信息',
    backUp: '返回应用管理',
    deleteApp: '删除应用',
    voucher: '凭证与基础信息',
    authManage: '权限管理',
    createSuccess: '创建成功',
    createError: '创建失败',
    modifySuccess: '修改成功',
    modifyError: '修改失败',
    delSuccess: '删除成功',
    delError: '删除失败',
    modifyAuthSuccess: '批量设置成功',
    modifyAuthError: '批量设置失败',
    deleteApiConfirm: '删除确认',
    appNumLimit: '应用数量达到上限，无法继续创建',
    ipFormatError: 'IP范围格式错误',
    deleteConfirmTitle: '您确定要删除该应用吗？',
    deleteApiDesc: '请检查应用信息，删除后不可恢复，凭证将失效',
    imgFormatLimit: '仅支持上传JPG/PNG格式',
    imgBulkLimit: '图片必须小于120KB',
    imgSizeLimit: '图片必须为240*240px以上',
    imgTip: '请上传JPG/PNG格式、240*240px以上、1:1 、120kb以内的无圆角图标',
    appNameRequired: '应用名称不能为空',
    appNameIsExit: '应用名称已被占用',
    ipRequired: '请添加访问IP',
    nodesc: '暂未添加任何描述',
    appDescTip: '请输入应用描述，不超过200个字符',
    appVoucherDesc:
      '应用凭证包含Appkey和AppSecret两个字段，该字段是调用API时需要传递的凭证信息，使用者应该妥善保存。',
    baseInfoDesc: '基础信息包含了应用名称和应用描述等信息，使用者可以按需修改此信息。',
    ipDesc:
      '为防止任意IP连接应用，需要添加访问应用的IP才可使用，不在添加范围内的IP则无法连接应用。',
    authDesc: '通过权限管理可以管控应用程序可调用的接口能力，选中的权限为可调用接口。',
    rateDesc:
      '为防止应用程序频繁调用而引发服务器负载异常，默认情况下，每个服务端接口调用都有频率限制，当超过此限制时，调用对应接口时会返回对应错误码。',
    rateCount:
      '每个接口一分钟内最大请求次数，最大可设置{0}次/分钟，如需设置更大的接口频率次数，需要增加应用包数量',
    rateLimitTip: '超过上限{0}',
    intSpace: '请输入正整数',
    rateRequired: '应用频率限制不能为空',
    ratePlaceholder: '请输入内容',
    rateMinLimit: '不可小于100次/分钟',
    rateFormat: '必须设置100的倍数',
    integrated: '集成管理',
    createIntegrated: '创建集成模板',
    deleteIntegrated: '删除集成模板',
    integratedInfo: '集成模板信息',
    message: '消息',
    backIntegrated: '返回集成管理',
    systemName: '系统名称',
    integrationType: '集成类型',
    systemType: '系统类型',
    'main datacenter': '主数据中心',
    datacenter: '数据中心',
    scene: '适用场景',
    status: '状态',
    Prerequisites: '已配置',
    unconfined: '暂未配置',
    operation: '操作',
    set: '设置',
    err_region: '请选择数据中心',
    region_tip: '该数据中心已配置',
    systemIcon: '系统图标',
    systemNameTip: '该系统名称已被占用',
    baseInfoTip: '如需改为其他模板类型，请您删除本模板，重新选择并创建',
    ipManagement: 'IP管理',
    ipWhite: 'IP白名单',
    ipExclude: '用户在此IP段内访问时不做双因子认证',
    addIp: '添加访问IP：',
    ipTip: '填写访问此应用的IP，多个IP请以“,”隔开，支持填写IP段，IP起始地址与终止地址使用“-”隔开',
    ipPlc: '请输入IP地址',
    save: '保存',
    Restore: '恢复',
    ipError: 'IP地址填写错误',
    saveSuccess: '保存成功',
    messageTemplate: '消息模板',
    templateDesc: '模板内容为发送验证码的消息示例',
    messageDesc: '{}中的内容无法修改，修改后将无法正常发送消息内容',
    setTemplate: '设置模板',
    messageNotNull: '消息内容不可为空，请填写内容',
    messageTip: '消息内容不符合规范，请预留验证码字段，如{XXXXXX}',
    deleteConfirm2: '删除确认',
    deleteTip: '您确定要删除该集成模板吗？',
    deleteDesc: '删除后不可恢复，所有配置将失效',
    deleteSuccess: '删除成功',
    comfirm: '确定',
    templateInfo: '模板信息',
    baseInfo2: '基本信息',
    editApp: '编辑信息',
    messageError: '消息模板为空，无法提交',
    editAppDialog: '编辑集成模板',
    setMessage: '设置消息模板',
    messagePlc: '登录验证码为：{XXXXXX}，请尽快完成验证，如非本人操作，请忽略本消息',
    inputTip: '最多输入100个字符',
    createErrorTip: '集成类型已达到上限，无法继续创建',
    deleteApproveDesc: '删除该审批集成应用后，网盘内的审批将无法正常使用',
    imgFormatLimit2: '仅支持上传JPG/PNG格式',
    imgBulkLimit2: '图片必须小于120KB',
    imgSizeLimit2: '图片必须为240*240px以上',
    actionConfirm: '操作确认',
    stopTip: '确认要停止该插件吗？',
    stopDesc: '停止后会导致该插件对应的服务失效',
    listDeleteTip: '确认要删除该插件吗？',
    listDeleteDesc: '删除后会导致该插件对应的服务失效',
    integratedVoucherDesc:
      '应用凭证包含Appkey和AppSecret两个字段，该字段是调用集成应用时需要传递的凭证信息，使用者应该妥善保存。',
    integratedTmpInfo: '集成信息包含了集成类型和系统类型，如需更改可删除后重新创建。',
    integratedBaseInfo: '基础信息包含了应用名称和应用配置等信息，使用者可以按需修改此信息。',
  },
  document: {
    header: {
      title: '开放平台',
      api: '服务端API',
      login: '登录',
      tools: '开发工具',
    },
    noResponseExample: '无返回示例',
    Summary: '概述',
    ProductGuide: '产品指南',
    IntroductionToTerms: '名词介绍',
    usageMethod: '使用方法',
    getToken: '获取Token',
    useToken: '使用Token',
    GlobalReturnCode: '全局返回码',
    updateTime: '更新时间',
    UpdateTimeValue: '2021年5月10日',
    InterfaceDesc: '接口说明',
    baseInfo: '基本信息',
    requestType: '请求方式',
    requestAddress: '请求地址',
    requestParam: '请求参数',
    param: '参数',
    type: '类型',
    action: '操作类型',
    name: '名称',
    required: '必须',
    place: '位置',
    desc: '描述',
    default: '默认值',
    requestExamples: '请求示例',
    responseParam: '返回参数',
    responseExample: '返回示例',
    yes: '是',
    no: '否',
    api_file_list: '获取文件列表',
    api_file_list_desc: '通过此接口可以获取文件列表',
    ContentType_field_desc: '必须为application/x-www-form-urlencoded',
    modified_field_desc: '最后修改时间',
    path_field_desc: '上传路径（全路径，如：/a/b/test.txt）',
    pathType_field_desc: '路径类型: ent 企业空间，self 个人空间',
    rev_field_desc: '文件版本',
    size_field_desc: '文件大小',
    creator_field_desc: '创建者',
    creatorUid_field_desc: '创建者id',
    updator_field_desc: '更新者',
    updatorUid_field_desc: '更新者id',
    isteam_field_desc: '是否为团队文件夹',
    filedata_field_desc: '文件本体',
    api_f_name: '创建文件夹',
    file: '文件',
    team: '团队',
    user: '用户',
    api_box_sessionid: 'Sessionid',
    api_errorcode: '错误码，成功：0',
    api_token_field_desc:
      '格式为Basic base64([appKey]:[appSecret]),例如，对于appKey=aaa和appSecret=bbb，你需要先拼接出“aaa:bbb”，然后进行base64编码，最终的请求头为Authorization: Basic YWFhOmJiYg==',
    api_token_path_field_desc: '此处需填写固定值client_with_su',
    api_token_path_field_desc_scope: '应用能对用户做的操作范围。此处需填写固定值all',
    api_token_slug: '用户登录名。这表示生成token后能代表哪个用户调用API。',
    api_get_token_error: '获取token失败',
    api_token_error: 'token过期或者不存在',
    api_token_scope: '应用能对用户做的操作范围。与申请令牌时填写的一致。',
    api_token_token_type: '目前固定为bearer',
    api_token_access_token: '获取到的令牌',
    api_token_expires_in: '令牌的有效时间（秒）',
    api_token_cankao: '参考',
    api_token_yuanyin: '原因',
    api_token_chenggong: '请求成功',
    api_token_shibai: '参数错误',
    api_token_yichang: '鉴权异常',
    api_token_jinzhi: '操作被禁止',
    api_token_bucunzai: '请求的实体不存在',
    api_token_buyunxu: '不允许使用请求行中所指定的方法',
    api_token_chongtu: '请求的资源冲突',
    api_token_weimanzu: '请求的资源未满足前提条件',
    api_token_cuowu: '服务内部错误',
    api_token_fanhui: '返回字段',
    api_token_zhuyishixiang: '注意事项',
    api_token_zhuyishixiang_decs1:
      '开发者需要缓存access_token，用于后续接口的调用（注意：不能频繁调用此接口，否则会受到频率拦截）。当access_token失效或过期时，需要重新获取。',
    api_token_zhuyishixiang_decs2:
      'access_token的有效期通过返回的expires_in来传达，同一应用在有效期内重复针对同一用户获取令牌将返回相同结果，过期后获取会返回新的access_token。',
    api_token_zhuyishixiang_decs3:
      '由于运营策略，不保证token在有效期内持续有效。开发者应实现access_token失效时重新获取的逻辑。',
    api_token_zhuyishixiang_decs4: 'access_token至少保留512字节的存储空间。',
    api_use_token_decs1:
      '获取到token后，就能使用开放平台提供的API了。在调用API时，只需要添加如下所示的Authorization请求头即可。',
    api_use_token_decs2: 'Authorization: bearer [token]',
    api_use_token_decs3: '请将[token]替换为之前已获取的token内容。',
    api_token_subtitle:
      '获取token是调用开放平台API接口的第一步，几乎所有的业务API接口都需要依赖于token来确定调用方（应用，app）和用户（user）身份。',
    api_chanpinzhinan_decs1:
      'Filez开放平台是基于zBox基础业务和功能向企业提供二次开发的服务平台，为企业提供智能安全的多人文件编辑、协作与管理的解决方案。平台面向企业或第三方开发人员，通过开放接口与企业内部系统实现对接，满足企业个性化的文件管理需求。',
    api_chanpinzhinan_decs2:
      'Filez提供了文件操作、链接管理、团队管理、用户管理四个部分的API，企业可以使用这些API，为企业的文件管理赋能助力。',
    api_mingcijieshao1: '1. 应用（app）',
    api_mingcijieshao_decs1:
      '一个应用（app）代表一个开放平台API的调用主体。目前开放平台API不提供匿名访问机制，因此需要持有应用身份信息（详细信息见令牌解释）才能使用开放平台提供的API。',
    api_mingcijieshao_decs2: '应用身份信息包含两个字段：',
    api_mingcijieshao_decs3: 'appKey，用于唯一确定一个应用的信息（相当于用户名）',
    api_mingcijieshao_decs4: 'appSecret，用于防止应用信息被冒用（相当于密码）',
    api_mingcijieshao_decs5:
      '这两个字段由开放平台提供，开放平台API的调用者应该妥善保存。为确保安全性，对于appSecret，应该只在后台调用时传递。',
    api_mingcijieshao2: '2. 用户（user）',
    api_mingcijieshao_decs7: '用户（user）在本文档若无特殊说明特指filez Box用户。',
    api_mingcijieshao3: '3. 令牌（token）',
    api_mingcijieshao_decs8:
      '令牌（token）是调用所有API都需要传递的凭证信息。若想调用API需要携带应用信息和用户信息到指定的端点申请令牌（详见后续部分）。这就意味着一个令牌对应一个应用信息和一个用户信息。若想使用若干不同用户的身份调用API，则需要针对每一个用户申请一次令牌。',
    api_mingcijieshao4: '4. 参数',
    api_mingcijieshao_decs9:
      '调用API需要传递参数。在后续章节中，我们使用方括号来代表需要传递的参数。如token=[token]，就代表需要将[token]替换为需要传递的参数。另外，有些参数需要用某些函数处理，处理函数我们使用斜体表示，如base64([token])，表示将token参数传递后，再做一次base64编码处理。',
    orgteam: '组织',
    createOrgteam: '新建组织',
    modifyOrgteam: '更新组织',
    deleteOrateam: '删除组织',
    dismissOrateam: '解散组织',
    getListOfOrateam: '获取组织列表',
    getInfoOfOrateam: '获取组织信息',
    BatchPreview: '批量预览',
    api_dept_update_desc_1: '根据组织id更新组织信息',
    OrguserCreate: '创建组织用户关系',
    authorize: '授权（共享）',
    modifyAuth: '添加修改授权（共享）',
    cancelAuth: '取消授权（共享）',
    getAuthList: '获取授权（共享）列表',
    onlineEditing: '在线编辑',
    bookmarkId_field_desc: '收藏id',
    supportPreview_field_desc: '是否支持预览',
    isBookmark_field_desc: '是否收藏',
    fileSearch: '文件搜索',
    authorization: '格式为bearer [token]',
    nsid: '命名空间id',
    errCode: '错误码，成功：0',
    errMsg: '错误描述，成功：ok',
    path: '路径',
    isSubteamInheritable: '是否可继承',
    neid: '文件id',
    pathType: '路径类型',
    updator: '更新者',
    updatorId: '更新者id',
    updatorUid: '更新者id',
    size: '文件大小',
    creator: '创建者',
    creatorId: '创建者id',
    creatorUid: '创建者id',
    fileVersion: '文件版本',
    dateTime: '2021年10月27日',
  },
  api: {
    install: '安装',
    import: '导入',
    get: '获取 accessToken',
    full: '填入 accessToken',
    downloadSDK: '下载SDK',
    environmental_dependence: '依赖环境',
    dependent_package: '依赖包：',
    api_dowload_sdk_request_example: 'SDK请求示例',
    api_dowload_sdk_download: 'SDK下载地址',
    api_dowload_sdk_manual_download: 'SDK使用手册下载',
    api_dowload_sdk_postman_invocation: 'postman调用',
    api_dowload_sdk_document_postman: '下载postman文件',
    api_dowload_sdk_desc: 'Filez开放平台提供了统一的SDK，使用SDK可以便捷地调用Filez网盘API',
    api_dowload_sdk_request_example_tip: '下面是使用SDK调用API的请求示例：',
    api_dowload_sdk_api_notes_1:
      '初始化boxSDK，创建oauthClient获取accessToken，创建请求对应的client。',
    api_dowload_sdk_api_notes_2: '调用创建用户请求',
    api_dowload_sdk_api_following: '请求示例说明',
    api_dowload_sdk_notes_1:
      '1.apiUrl为对接Filez网盘的地址，slug为调用api的使用者，之后生成的token只能被此用户使用。appKey、appSecret为应用凭证，如下图：',
    api_dowload_sdk_notes_2:
      '2.TokenModel包含字段：token信息(accessToken)、token类型(tokenType)、有效期(expiresIn)、以及作用域(scope)。',
    api_dowload_sdk_notes_3:
      '3.根据调用的接口类型，创建对应的client。例：调用创建用户接口，需创建userClient 。',
    api_dowload_sdk_notes_4:
      '4.调用请求使用client中接口对应的方法，例：创建用户调用userClient .create()方法，每个方法都需要传入TokenModel.getAccessToken(),具体的方法及参数见SDK中client接口注释。',
    api_dowload_sdk_notes_5:
      '5.SDK中，用户相关操作调用示例类UserClientSample，团队相关操作调用示例类TeamClientSample，文件相关操作调用示例类FileClientSample，外联相关操作调用示例类DeliveryClientSample，组织相关操作调用示例类OrgClientSample，组织下用户相关操作调用示例类OrgUserClientSample。',
    api_dowload_sdk_install: '手动将java-sdk-2.2.jar添加到项目中。',
    api_dowload_sdk_environmental_dependence: 'Java SDK 需要依赖 Java SE/EE 1.7及以上。',
    api_dowload_sdk_download_book: 'Java SDK使用手册',
    api_dowload_sdk_postman_desc: '本文档主要介绍联想Filez开放平台API Postman工具的使用。',
    api_dowload_sdk_postman_desc_1: '1. 将Marne Api.postman_collection.json文件导入到Postman中。',
    api_dowload_sdk_postman_get_accessToken_1:
      '1. 调用获取token接口/v2/oauth/token，选择认证类型Basic Auth，Username为appKey，',
    api_dowload_sdk_postman_get_accessToken_2:
      '2. 请求参数grant_type为固定值client_with_su，scope为固定值all，slug为用户登录名。',
    api_dowload_sdk_invocation_example: '调用示例',
    webtoolSDK: '批量下载工具',
    webtoolDesc:
      '批量下载工具用于三方系统对接Filez后实现批量下载功能。当三方系统对接Filez的下载功能后，终端用户在对接的系统内做批量下载时，可以唤起批量下载工具进行批量下载。因此需要保证终端用户电脑上必须安装批量下载工具，同时该工具仅支持Windows终端。',
    toolSchematic: '工具示意图',
    webtoolDesc2:
      '可查看下载详情，同时支持下载任务管理，针对下载中的任务可进行开始、暂停、取消操作。',
    webtoolDesc3: '可对默认下载路径进行自定义设置',
    downloadLink: '下载链接',
    documentLink: '文档链接',
  },
}



// WEBPACK FOOTER //
// ./static/js/language/zh.js